import { apiRequest } from "./client";

export const activityApi = {
  trackPanel(payload) {
    return apiRequest("/activity/panel", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  project(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/activity`, { params });
  },
  projectSummary(projectId, hours = 24) {
    return apiRequest(`/projects/${projectId}/activity/summary`, { params: { hours } });
  },
  projectJourneys(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/activity/journeys`, { params });
  },
  websiteAnalytics(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/activity/website-analytics`, { params });
  },
  businessAnalytics(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/activity/business-analytics`, { params });
  },
};
